// extracted by mini-css-extract-plugin
export default {"button":"FormButton_button__+u67Z","buttonText":"FormButton_buttonText__6xleK","icon":"FormButton_icon__NNwJh"};